import {
  FreeGameType,
  MediaFeedType,
  MediaState,
  MediaType,
  VideoColorSpace,
  VideoResolution,
} from '@optools/services/operator-gateway/types/generated/graphql';
import { z } from 'zod';

export const broadcastsParamsSchema = z.object({ mediaId: z.string() });

export const broadcastsSearchSchema = z.object({
  availableForStreaming: z.boolean().optional(),
  feedType: z.enum(MediaFeedType).optional(),
  language: z.string().optional(),
  mediaType: z.enum(MediaType).optional(),
});

export const broadcastFormSchema = z.object({
  // TODO: add back in when bin api changes are made
  // availability: z.nativeEnum(BroadcastAvailability),
  availableForStreaming: z.boolean(),
  colorSpace: z.enum(VideoColorSpace).optional().nullable(),
  freeGameStatuses: z.array(
    z.object({
      freeGameType: z.enum(FreeGameType),
      status: z.boolean(),
    }),
  ),
  mediaState: z.enum(MediaState),
  mvpdRequired: z.boolean(),
  videoResolution: z.enum(VideoResolution).optional().nullable(),
});

export type BroadcastFormValues = z.infer<typeof broadcastFormSchema>;
